<template>
    <line-chart
        v-if="row.prev_months && row.prev_months.length > 0"
        :tooltips="false"
        :display-axes="false"
        :display-y="false"
        :display-x="false"
        :display-y-grid="false"
        :display-x-grid="false"
        :display-legend="false"
        :points="12"
        :suggested-y-max="topGrossForWeek"
        :chart-data="chartData"
        :animate="false"
    />
</template>

<script>
export default {
    props: ['row'],
    computed: {
        chartData() {
            return this.row.prev_months.map(item => ({
                x: [
                    {
                        label: 'Gross',
                        value: item.gross > 0 ? item.gross : NaN,
                    },
                    {
                        label: 'Potential Gross',
                        value:
                            item.gross_potential > 0
                                ? item.gross_potential
                                : NaN,
                    },
                ],
                y: item.date,
            }));
        },
        topGrossForWeek() {
            return Math.max(
                ...this.$store.state.week.grosses
                    .filter(gross => typeof gross.prev_months !== 'undefined')
                    .map(gross =>
                        Math.max(
                            ...gross.prev_months.map(month =>
                                Math.max(month.gross_potential, month.gross),
                            ),
                        ),
                    ),
            );
        },
    },
};
</script>
